import { Box, Typography } from "@mui/material";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import UsersTable from "../components/Users/UsersTable";
import { MOCK_USERS } from "../constants/users.consts";
import { PaginationModel, QueryOptions } from "../interfaces/pagination";
import { User } from "../interfaces/user";
import { useAllUsers } from "../services/users";
import PageTitle from "../components/PageTitle";

const UsersPage = () => {
  const [users, setUsers] = useState<User[]>([]);
  // const [isLoading, setIsLoading] = useState<boolean>(true);

  const [paginationModel, setPaginationModel] = useState<PaginationModel>({
    page: 0,
    pageSize: 25,
  });

  const [rowCount, setRowCount] = useState<number>(users.length);

  const [queryOptions, setQueryOptions] = useState<QueryOptions>({});

  const timeoutRef = useRef<number | null>(null);

  const handleFilterModelChange = useCallback(
    (filterModel: GridFilterModel) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        setQueryOptions((prev) => {
          if (
            filterModel.quickFilterValues &&
            filterModel.quickFilterValues.length > 0
          ) {
            setPaginationModel((prev) => ({
              ...prev,
              page: 0,
            }));

            const search = filterModel.quickFilterValues.join(" ");
            return { ...prev, search };
          } else {
            const { search, ...others } = prev;
            return others;
          }
        });
      }, 300);
    },
    []
  );

  const handleSortModelChange = useCallback((sortModel: GridSortModel) => {
    setQueryOptions((prev) => {
      if (sortModel.length > 0) {
        setPaginationModel((prev) => ({
          ...prev,
          page: 0,
        }));

        const ordering = `${sortModel[0].sort === "desc" ? "-" : ""}${
          sortModel[0].field
        }`;
        return { ...prev, ordering };
      } else {
        const { ordering, ...others } = prev;
        return others;
      }
    });
  }, []);

  const {
    data: usersData,
    mutate,
    isLoading,
  } = useAllUsers({
    ...paginationModel,
    ...queryOptions,
  });

  useEffect(() => {
    setUsers(usersData?.results || []);

    setRowCount((prevRowCount) => (usersData ? usersData.count : prevRowCount));
  }, [usersData]);

  return (
    <>
      <PageTitle title="Users"/>
      <Box sx={{}}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <UsersTable
            users={users}
            rowCount={rowCount}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleFilterModelChange={handleFilterModelChange}
            handleSortModelChange={handleSortModelChange}
            isLoading={isLoading}
            mutate={mutate}
          />
        )}
      </Box>
    </>
  );
};

export default UsersPage;
